<section>
  <h2>{{ title() | uiLabelTranslate }}</h2>
  @if (description()) {
    <p>{{ description() | uiLabelTranslate }}</p>
  }
  <ng-content />
</section>
